<template lang="pug">
  .historia
    MercadoJumbo(:title="content.title", :small="content.small", :img="content.img")
    h4.bajada(v-html="content.description")
    .blocks.block1
      .col
        .content(v-html="content.blocks[0].content")
    .blocks
      .col-title
        h2 {{content.blocks[1].title}}
      .col
        .laterales
          .lateral(v-for="(lateral, index) in content.blocks[1].laterales" :key="index")
            h3 {{lateral.title}}
              small {{lateral.content}}
          span Fuente: estudio llevado a cabo por Mercado Libre en conjunto con GfKAdimark, en 2017
        //- img.img-yellow(:src="content.blocks[1].img", alt="content.blocks[1].title")
      .col
        .content(v-html="content.blocks[1].content")
    .blocks
      .col
        .content(v-html="content.blocks[2].content")
      .col
        img.img-yellow(:src="content.blocks[2].img", alt="content.blocks[2].title")
    //- .percentages
    //-   Percentages(:percentages="content.percentages")

    .blocks.final
      .bajada(v-html="content.blocks[3].content")
      .link
        a(:href="content.blocks[3].url", title="Ver Cybermonday 2018") Visita Mercado Libre y prepárate para el CyberMonday

    .brands
      Brands(:brands="content.brands")
    Carousel(:items="content.carousel")
</template>

<script>
import MercadoJumbo from '@/components/mercadolibre/MercadoJumbo'
import Percentages from '@/components/mercadolibre/Percentages'
import Brands from '@/components/mercadolibre/Brands'
import Carousel from '@/components/mercadolibre/Carousel'

export default {
  components: {
    MercadoJumbo,
    Percentages,
    Brands,
    Carousel
  },
  computed: {
    content() {
      const content = this.$store.getters.getContent(0)
      return content;
    }
  }
}
</script>
<style scoped lang="scss">
.home{

}
.bajada{
  padding: 3rem 1rem;
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
  font-size: 1.4rem;
  font-weight: normal;
  >>>strong{
    color: rgb(255, 133, 133);
  }
}
.blocks{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 4rem;
  max-width: 1100px;
  margin: 0 auto;
  padding: 3rem 1rem;
  &.block1,
  &.final{
    max-width: 650px;
    grid-template-columns: repeat(1, 1fr);
    padding: 1rem;
    grid-gap: 1rem;
    .bajada{
      padding: 0;
    }
    .link{
      display: flex;
      justify-content: center;
      a{
        border-radius: 4px;
        background-color: #ffe600;
        border: 1px solid #d9cd4b;
        font-size: 1.3rem;
        line-height: 2rem;
        padding: 1rem 2rem;
        text-align: center;
        color: #333;
      }
    }
  }
  .col-title{
    grid-column: 1 / -1;
    h2{
      text-align: center;
      font-weight: normal;
    }
  }
  .lateral{
    padding: 1rem 0;
    h3{
      font-size: 6rem;
      letter-spacing: -3px;
      line-height: 5rem;
      padding-bottom: 1rem;
      position: relative;
      margin-bottom: 1rem;
      small{
        font-size: 2rem;
        line-height: 2.2rem;
        font-weight: normal;
        display: block;
        letter-spacing: -1px;
      }
      &:after{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 60%;
        border: 6px solid $yellow;
      }
    }
  }
  @media (max-width: 800px){
    grid-template-columns: repeat(1, 1fr);
  }
  .content{
    font-size: 1rem;
    line-height: 160%;
  }
}
.percentages,
.brands{
  max-width: 1100px;
  margin: 0 auto;
  overflow: hidden;
}

img{
  max-width: 100%;

  &.img-yellow{
    padding-left: 3rem;
    padding-bottom: 3rem;
    background-color: $yellow;
  }
  &.img-blue{
    padding-left: 0;
    padding-right: 3rem;
    padding-bottom: 3rem;
    background-color: $blue;
  }
}

</style>